import { render, staticRenderFns } from "./CmgLoyaltyProgressBar.vue?vue&type=template&id=42155b54&scoped=true&lang=pug"
import script from "./cmg-loyalty-progress-bar.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-progress-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyProgressBar.vue?vue&type=style&index=0&id=42155b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42155b54",
  null
  
)

export default component.exports